import React from 'react';
import { DownloadSimple, Plus, List } from '@phosphor-icons/react';
import { useSidebar } from '../contexts/SidebarContext';

const Topbar = ({ title, breadcrumb, onAdd, onExport, showAdd = false, showExport = false }) => {
  const { toggleSidebar, isMobile } = useSidebar();
  
  return (
    <header className="bg-[#13161e] border-b border-[#2a2e3d] px-4 md:px-6 py-4 flex items-center justify-between" data-testid="topbar">
      <div className="flex items-center gap-3">
        {isMobile && (
          <button
            onClick={toggleSidebar}
            className="text-[#8b949e] hover:text-white transition-colors p-1"
            data-testid="menu-toggle"
          >
            <List size={24} weight="bold" />
          </button>
        )}
        <div>
          <h1 className="text-white font-['Fraunces'] text-xl md:text-2xl font-bold" data-testid="page-title">{title}</h1>
          <div className="text-[#8b949e] font-['IBM_Plex_Mono'] text-xs mt-1 hidden sm:block" data-testid="breadcrumb">{breadcrumb}</div>
        </div>
      </div>
      <div className="flex items-center gap-2 md:gap-3">
        {showExport && (
          <button
            onClick={onExport}
            className="flex items-center gap-2 px-2 md:px-4 py-2 bg-transparent border border-[#2a2e3d] text-white rounded-sm hover:border-[#4f9eff] transition-colors font-['IBM_Plex_Mono'] text-xs md:text-sm"
            data-testid="export-button"
          >
            <DownloadSimple size={16} weight="bold" />
            <span className="hidden sm:inline">Exportar</span>
          </button>
        )}
        {showAdd && (
          <button
            onClick={onAdd}
            className="flex items-center gap-2 px-2 md:px-4 py-2 bg-[#4f9eff] text-[#0d0f14] rounded-sm hover:bg-[#4f9eff]/90 transition-colors font-['IBM_Plex_Mono'] text-xs md:text-sm font-bold"
            data-testid="add-button"
          >
            <Plus size={16} weight="bold" />
            <span className="hidden sm:inline">Agregar</span>
          </button>
        )}
      </div>
    </header>
  );
};

export default Topbar;